import { apiFetch } from '../../../../utils';
import { useEffect, useState } from 'react';

const initialState = { contact: {}, fields: [], ready: false };

/**
 * Queries and caches review contact information.
 *
 * A review contact includes a `contact` object with fields configured for the review year as well as `fields`,
 * an array of definitions for the aforementioned contact fields.
 *
 * @param contactId the contact ID
 * @param schoolYearId the school year ID
 * @return {{ready: boolean, contact: {}, fields: *[]}}
 */
const useReviewContact = ({ contactId, schoolYearId }) => {
  const key = contactId + ':' + schoolYearId;
  const [reviewContacts, setReviewContacts] = useState({});
  const reviewContact = reviewContacts[key] || initialState;

  useEffect(() => {
    if (contactId && schoolYearId && !(key in reviewContacts)) {
      setReviewContacts({ ...reviewContacts, [key]: reviewContact });

      apiFetch.get({}, `review_contacts/${contactId}?school_year_id=${schoolYearId}`)
        .then(({ contact, fields }) => {
          setReviewContacts({
            ...reviewContacts,
            [key]: { contact, fields, ready: true }
          });
        })
        .catch(() => setReviewContacts({
          ...reviewContacts,
          [key]: { ...reviewContact, ready: true, error: true }
        }));
    }
  }, [contactId, schoolYearId]);

  return reviewContact;
};

export default useReviewContact;
